import Grid from "@mui/material/GridLegacy";
import CategorySkeletonTile from "./CategorySkeletonTile";

const CategorySkeletonTiles = ({ template_page_settings }) => {
    return (
        <Grid container>
            {/* create an array of 12 elements to loop through */}
            {Array.from(Array(12)).map((_element, idx) => (
                <Grid key={idx}
                    xl={12 / 4}
                    lg={3} md={3} sm={6} xs={6} item>
                    <CategorySkeletonTile />
                </Grid>
            ))}
        </Grid>
    )
}

export default CategorySkeletonTiles